import autobind from 'core-decorators/lib/autobind';
import { FormattedMessage } from 'react-intl';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import getUrlToVideo from 'widget/player-widget/utils/get-url-to-video';
import { pickContextTypes } from '../../context-types';

import socialNetworkNames from 'widget/player-widget/constants/social-networks';

import SocialShare from 'widget/player-widget/components/social-share/social-share';

import styles from './share.styl';

import translations from './translations';


@WixConnect(styles)
export default class InfoOverlayShare extends React.Component {

  static contextTypes = pickContextTypes('videoItem', 'openPreviewPrompt', 'afterShareClicked');

  static propTypes = {
    network: React.PropTypes.string,
    appSettings: React.PropTypes.object,
  };

  @autobind
  broadcastAfterClickToContext(network) {
    this.context.afterShareClicked(network);
  }

  render() {
    const { videoItem, openPreviewPrompt } = this.context;
    const { appSettings } = this.props;

    const networksClassNames = _.pick(styles, _.values(socialNetworkNames));

    const contentToShare = {
      ...videoItem,
      siteUrl: getUrlToVideo(videoItem, appSettings),
    };

    return (
      <div styleName="share-overlay"
           className="qa-player-overlay-share">
        <div styleName="title">
          <FormattedMessage {...translations.share} />
        </div>
        <SocialShare appSettings={appSettings}
                     networks={_.values(socialNetworkNames)}
                     content={contentToShare}
                     onAfterClicked={this.broadcastAfterClickToContext}
                     styleName="social-icons"
                     buttonClassName={styles['share-icon']}
                     linkClassName={styles['share-link']}
                     networksClassNames={networksClassNames}
                     openPreviewPrompt={openPreviewPrompt} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/info-overlay/share/share.js